import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import Tooltip from "./tooltip"
import { useIntl } from "react-intl"
import { removeSpaces } from "../../utils"

interface BarProps {
	data: Array<any>
	colorPalette: any
}

export const Bar: React.FC<BarProps> = ({ data, colorPalette }) => {
	const intl = useIntl()
	const validateType = data.find((e) => e.gender)
	return (
		<ResponsiveBar
			data={data}
			keys={["value"]}
			indexBy={!validateType ? "age" : "gender"}
			margin={{ top: 10, right: 60, bottom: 50, left: 60 }}
			layout="horizontal"
			valueScale={{ type: "linear" }}
			indexScale={{ type: "band", round: true }}
			colors={colorPalette}
			colorBy={"indexValue"}
			enableGridY={false}
			enableGridX={true}
			enableLabel={false}
			axisBottom={{
				tickRotation: -45,
				format: (item) => `${item}%`,
				tickSize: 0,
			}}
			axisLeft={{
				format: (item) => {
					if (validateType) {
						return intl.formatMessage({
							id: `phronesis.common.${removeSpaces(item.toLowerCase())}`,
						})
					}
					return `${item}`
				},
				tickSize: 0,
			}}
			borderRadius={2}
			tooltip={(values) => (
				<Tooltip
					indexValue={values.indexValue.toString()}
					data={values.data}
					color={values.color}
				/>
			)}
		/>
	)
}
